import { Dropdown, DropdownToggle, DropdownMenu, Radio } from "@ht/components";
import clsx from "clsx";
import { FC, useState } from "react";
import { PresenceBox } from "../../../components/presence-box";

interface IProp {
    checkState: {
        chatConnected?: boolean;
        vcallConnected?: boolean;
        sipConnected?: boolean;
        callpresence?: string;
    };
    onChange(reason: string, label: string): void;

}

const PresenceDropdown: FC<IProp> = ({ checkState, onChange }) => {
    const [showPresenceBox, setShowPresenceBox] = useState(false);
    const [reasonString, setReasonString] = useState("");
    const { chatConnected, vcallConnected, sipConnected, callpresence } = checkState;
    const handleOnline = () => {
        setReasonString("");
        setShowPresenceBox(false);
        onChange("", "");
    };
    const handleOffline = ({
        reason,
        label,
    }: {
        reason: string;
        label: string;
    }) => {
        setReasonString(label);
        setShowPresenceBox((state) => !state);
        onChange(reason, label);
    };
    const getFlag = () => {
        let connectedflag = 0;

        if (chatConnected !== undefined) {
            if (chatConnected) connectedflag++;
        }
        if (vcallConnected !== undefined) {
            if (vcallConnected) connectedflag++;
        }
        if (sipConnected !== undefined) {
            if (sipConnected) connectedflag++;
        }
        if(callpresence == 'ACW') return false;
        return connectedflag > 0;
    };

    return (
        <>
            <Dropdown
                direction="down"
                hideOnClick={false}
                isOpen={reasonString}
                showIcon={true}
                className="-ml-[6px] -mt-[2px]"
                shape
            >
                <DropdownToggle
                    variant="texted"
                    color="light"
                    shape="square"
                    iconClass="text-gray-400"
                    className="text-2xl hover:!text-primary w-[32px] h-[32px] pl-[1px] relative content-start"
                >
                    {""}
                </DropdownToggle>
                <DropdownMenu
                    className={clsx(
                        "p-0 rounded-lg -mr-[22px] right-0 left-auto"
                    )}
                >
                    <div className="p-2 w-[120px]">
                        <div className="flex flex-col gap-[2px]">
                            <div className="text-base font-bold text-black">
                                Status
                            </div>
                            <div className="flex flex-col gap-[6px]">
                                <label htmlFor="online">
                                    <div className="text-base text-black flex flex-row justify-between items-center gap-[4px] cursor-pointer">
                                        <div className="flex flex-row items-center gap-[4px]">
                                            <div className="w-[8px] h-[8px] rounded-full bg-success"></div>
                                            <span>Online</span>
                                        </div>
                                        <Radio
                                            id="online"
                                            name="online"
                                            label=""
                                            className="mb-[4px]"
                                            onChange={() => { }}
                                            onClick={() => {
                                                handleOnline();
                                            }}
                                            checked={getFlag()}
                                        ></Radio>
                                    </div>
                                </label>
                                <label htmlFor="offline">
                                    <div className="text-base text-black flex flex-row justify-between items-center gap-[4px] cursor-pointer">
                                        <div className="flex flex-row items-center gap-[4px]">
                                            <div className="w-[8px] h-[8px] rounded-full bg-danger"></div>
                                            <span>Offline</span>
                                        </div>
                                        <Radio
                                            id="offline"
                                            name="offline"
                                            label=""
                                            className="mb-[4px]"
                                            onChange={() => { }}
                                            onClick={() => {
                                                setShowPresenceBox(true);
                                            }}
                                            checked={!getFlag()}
                                        ></Radio>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </DropdownMenu>
            </Dropdown>
            <PresenceBox
                visible={showPresenceBox}
                yesHandler={(reason, label) => {
                    handleOffline({ reason, label });
                }}
                noHandler={() => {
                    setShowPresenceBox((state) => !state);
                }}
            />
        </>
    );
};
export default PresenceDropdown;
